import { createContext } from "react";
import type { TextStyle } from "./types";

// The width the text's lines fill and the style it is set in, for breaking words as the PDF does.
export const LineContext = createContext<{
  width: number;
  style?: TextStyle;
}>({ width: Infinity });
